import { useEffect, useState } from 'react';
import classnames from 'classnames/bind';
import { cloneDeep } from 'lodash';
import { EditableText } from 'taboola-ultimate-ui';
import { useSelectedReportIdParam } from '../../../campaigns/modules/campaigns-reports/hooks';
import { useDynamicReport } from '../../../scheduled-reports/hooks/useDynamicReport';
import styles from './DynamicReportNameEditor.module.scss';

const classNameBuilder = classnames.bind(styles);
export const DYNAMIC_REPORT_MAX_NAME_LENGTH = 60;

export const DynamicReportNameEditor = () => {
    const [selectedReport] = useSelectedReportIdParam();
    const { dynamicReport, isSuccess, setReportToCache } = useDynamicReport(selectedReport);
    const initialValue = dynamicReport?.name;
    const [cachedValue, setCacheValue] = useState(initialValue);
    const onBlur = () => setReportToCache(selectedReport, { ...cloneDeep(dynamicReport), name: cachedValue });

    useEffect(() => {
        if (isSuccess) {
            setCacheValue(initialValue);
        }
    }, [isSuccess, initialValue]);

    if (!isSuccess) {
        return null;
    }

    return (
        <EditableText
            maxLength={DYNAMIC_REPORT_MAX_NAME_LENGTH}
            value={cachedValue}
            iconName="edit-o"
            onChange={setCacheValue}
            onBlur={onBlur}
            className={styles['wrapper']}
            inputClassName={classNameBuilder('input', { empty: !cachedValue })}
            blurOnEnter
        />
    );
};
